export default "__VITE_ASSET__CGPnWO2r__"